import { useMutation } from '@apollo/client';
import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Gleap from 'gleap';
import { AppContext } from '../../AppContext';
import LoaderComponent from '../../components/LoaderComponent';
import { ROUTES } from '../../common/constants';
import { LOGOUT_USER } from './graphql/Mutations';

const Logout = () => {
  const { dispatch } = useContext(AppContext);
  const history = useHistory();
  const [logout, { loading, error }] = useMutation(LOGOUT_USER, {
    onError() {},
    onCompleted: () => {
      dispatch({ type: 'LOGOUT' });
      history?.push(ROUTES?.LOGIN);
      Gleap.clearIdentity();
    },
  });

  useEffect(() => {
    logout();
  }, []);

  if (loading) return <LoaderComponent />;

  if (error) {
    if (error?.graphQLErrors?.length) {
      const newErrors = error?.graphQLErrors?.[0];
      // eslint-disable-next-line no-console
      console?.log('newErrors => ', newErrors);
      dispatch({ type: 'LOGOUT' });
      history?.push(ROUTES?.LOGIN);
      return null;
    }

    history?.goBack();
    return null;
  }

  return null;
};

export default Logout;
